<template>
  <div>
    <table class="uk-table uk-table-small">
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th class="uk-text-right uk-text-capitalize">Netto</th>
          <th class="uk-text-right uk-text-capitalize">Brutto</th>
        </tr>
      </thead>
      <tbody>
        <tr style="border-top: 1px solid #e5e5e5" v-if="vehicle.newprice && showNewPrice">
          <td class="uk-text-bold">UPE*</td>
          <td class="uk-text-right">{{ newprice | euro }}</td>
          <td class="uk-text-right">
            {{ newpriceGross | euro }}
          </td>
        </tr>
        <tr>
          <td class="uk-text-bold" v-text="modePriceLabel"></td>
          <td class="uk-text-right">
            {{ saleprice }} €
          </td>
          <td class="uk-text-right">
            {{ salepricegross }} €
          </td>
        </tr>
        <!--
      <tr v-if="mode == 'merchant'">
        <td class="uk-text-bold">Aufschlag</td>
        <td class="uk-text-right">{{ surchargeNet | euro }}</td>
        <td class="uk-text-right">{{ surchargeGross | euro }}</td>
      </tr>
      -->
        <tr v-if="mode == 'merchant' && showCalculatedSalePrice" style="border-top: 1px solid #e5e5e5;">
          <td class="uk-text-bold">Kalkulierter Endkundenpreis</td>
          <td class="uk-text-right">{{ calculatedSalePrice | euro }}</td>
          <td class="uk-text-right">
            {{ calculatedSalePriceGross | euro }}
          </td>
        </tr>
      </tbody>
    </table>
    <p
      class="uk-padding-small uk-margin-remove-top uk-padding-remove-vertical uk-text-bold"
      v-if="(tenant.knumber === 'K10122' || tenant.knumber === 'K10151' || tenant.knumber === 'K10149') && vehicle.opendamages > 0"
    >
      Minderwert lt. Zustandsbericht: {{ vehicle.opendamages | euro }}
    </p>
    <p
      class="uk-padding-small uk-margin-remove uk-padding-remove-vertical uk-text-xsmall"
      v-if="vehicle.newprice && showNewPrice"
    >
      {{ newpriceInfoLabel }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    vehicle: {
      Required: true,
      Type: Object
    }
  },

  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed().replace('.', ',') //toFixed(2)
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  },

  computed: {
    ...mapGetters([
      'mode',
      'modePriceLabel',
      'showEndcustomerPrices',
      'showMerchantPrices',
      'tenant'
    ]),

    saleprice() {
      let price = this.vehicle.formatedSalepriceMerchant

      if (this.showEndcustomerPrices) {
        price = this.vehicle.salepriceEndcustomer
      }

      if (this.showMerchantPrices) {
        price = this.vehicle.salepriceMerchant
      }

      return price
    },

    salepricegross() {
      let price = this.vehicle.formatedSalepriceMerchantGross
      if (this.showEndcustomerPrices) {
        price = this.vehicle.salepriceGrossEndcustomer
      }

      if (this.showMerchantPrices) {
        price = this.vehicle.salepriceGrossMerchant
      }

      return price
    },

    newprice() {
      return this.vehicle.newprice / 1.19
    },
    newpriceGross() {
      return this.vehicle.newprice
    },

    surchargeNet() {
      return this.vehicle.tax
        ? this.vehicle.surchargeEndCustomer
        : this.vehicle.surchargeEndCustomerGross
    },

    surchargeGross() {
      return this.vehicle.surchargeEndCustomerGross
    },
    calculatedSalePrice() {
      return parseFloat(this.saleprice.replace('.', '')) + this.surchargeNet
    },
    calculatedSalePriceGross() {
      return parseFloat(this.salepricegross.replace('.', '')) + this.surchargeGross
    },
    newpriceInfoLabel() {
      if(this.tenant && this.tenant.knumber !== 'K10149' && this.tenant.knumber !== 'K10179') {
        if (this.tenant.knumber === 'K10122' || this.tenant.knumber === 'K10151') {
          return '*Ehem. Listenneupreis des Herstellers zum Zeitpunkt der Erstzulassung inklusive Werks-Frachtkostenpauschale (netto 500,-). Werte ohne Gewähr'
        }
        return '*Listenneupreis des Herstellers. Werte ohne Gewähr'
      }
      return ''
    },
    showNewPrice() {
      return this.tenant && (this.tenant.knumber !== 'K10137' && this.tenant.knumber !== 'K10149' && this.tenant.knumber !== 'K10179')
    },
    showCalculatedSalePrice() {
      return this.tenant && (this.tenant.knumber !== 'K10140')
    },
  }
}
</script>
